import CustomTitle from "./CustomTitle";

export {CustomTitle};